import axios from 'axios';

import { COST_CENTERS_ROSTER_CYCLE } from 'RestAPIs/endpoints';

export type RosterCycleEndResult = {
  nextOccurrence: string;
  cycleDate: string;
  rounds: RosterCycleRound[];
};

type RosterCycleRound = {
  start: string;
  end: string;
  autoConnect: boolean;
};

export type PlanningCycleRound = {
  startIndex: number;
  endIndex: number;
  autoConnect: boolean;
};

export type POSTBody = {
  rosterState: 'PUBLISHED' | 'VISIBLE';
  enabled: boolean;
  recurrenceRule: {
    start: string;
    periodType: 'MONTH' | 'WEEK';
    interval: number;
    dayOfMonth?: number;
    setPosition?: number;
    dayInWeekSet?: string[];
  };
  cycleWindow: number;
  rounds: PlanningCycleRound[];
};

export const getRosterCycleEndResult = (body: POSTBody, costCenterId: number) =>
  axios.post<RosterCycleEndResult[]>(
    COST_CENTERS_ROSTER_CYCLE,
    { ...body },
    {
      pathParams: {
        costCenterId
      }
    }
  );
